module.exports = __webpack_public_path__ + "img/1999.250cacb8.png";